import { render, staticRenderFns } from "./ThgBillingSelectionItemRegistrationData.vue?vue&type=template&id=874be3dc&"
import script from "./ThgBillingSelectionItemRegistrationData.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemRegistrationData.vue?vue&type=script&lang=ts&"
import style0 from "./ThgBillingSelectionItemRegistrationData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VCombobox,VForm,VIcon,VRow,VSkeletonLoader,VTextField,VTooltip})
